var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "productTypeDialog",
      attrs: {
        "append-to-body": true,
        title: "",
        visible: _vm.applyProjectShow,
        width: "70%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.applyProjectShow = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "Apply-Project" },
        [
          _c("h5", { staticStyle: { "margin-bottom": "10px" } }, [
            _vm._v("审批人配置"),
          ]),
          _c(
            "div",
            { staticClass: "Apply" },
            _vm._l(_vm.applyData, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "Apply-P" },
                [
                  _c(
                    "el-descriptions",
                    {
                      staticStyle: { padding: "20px", "padding-bottom": "0" },
                      attrs: { title: "" },
                    },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "审批类目" } },
                        [_vm._v(_vm._s(item.approvalKind))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "所属公司" } },
                        [_vm._v(_vm._s(item.createCompanyName))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "Apply-People",
                      style: {
                        padding: item.hierarchy.length == 0 ? "0" : "20px",
                      },
                    },
                    [
                      _vm._l(item.step, function (step, sindex) {
                        return _c(
                          "div",
                          { key: sindex, staticClass: "Apply-People-Step" },
                          [
                            _vm._l(
                              _vm.setShowDel(item.hierarchy, step),
                              function (people, pindex) {
                                return _c(
                                  "div",
                                  {
                                    key: pindex,
                                    staticClass: "Apply-People-For",
                                    on: {
                                      mouseenter: function ($event) {
                                        return _vm.enter(people)
                                      },
                                      mouseleave: function ($event) {
                                        return _vm.leave(people)
                                      },
                                    },
                                  },
                                  [
                                    people.imageUrl === ""
                                      ? _c("img", {
                                          attrs: {
                                            src: require("@/assets/png/moren.png"),
                                            alt: "",
                                          },
                                        })
                                      : _c("img", {
                                          attrs: {
                                            src: people.imageUrl,
                                            alt: "",
                                          },
                                        }),
                                    _c("p", [
                                      _c("span", [_vm._v("审批人：")]),
                                      _vm._v(_vm._s(people.applyName)),
                                    ]),
                                    _c("p", [
                                      _c("span", [_vm._v("审批层级：")]),
                                      _vm._v(_vm._s(people.step)),
                                    ]),
                                    _c("p", [
                                      _c("span", [_vm._v("消息提示：")]),
                                      _vm._v(
                                        _vm._s(
                                          people.tipInfo == 0
                                            ? "公众号"
                                            : people.tipInfo == 1
                                            ? "邮箱"
                                            : "短信"
                                        )
                                      ),
                                    ]),
                                    people.show
                                      ? _c(
                                          "div",
                                          { staticClass: "Top-Apply" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.delHierarchy(
                                                      people.id,
                                                      item.id
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("删除")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setHierarchy(
                                                      0,
                                                      item.id,
                                                      people.step
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("添加")]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }
                            ),
                            sindex + 1 < item.step
                              ? _c(
                                  "div",
                                  { staticClass: "Apply-People-Step-Line" },
                                  [_c("div", { staticClass: "mydiv" })]
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      }),
                      item.type == 1
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-left": "30px",
                                display: "flex",
                                "align-self": "center",
                                "padding-bottom": "10px",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "text-decoration": "underline",
                                  },
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setHierarchy(0, item.id, "")
                                    },
                                  },
                                },
                                [_vm._v("点击增加审批层级")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              )
            }),
            0
          ),
          _c("HierarchyAddOrUpdate", {
            ref: "hierarchyAddOrUpdate",
            on: { refreshDataList: _vm.getDataList },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }